import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import CoreBaseHero from './CoreBaseHero';
import CoreBaseSections from './CoreBaseSections';
import '../premiumLanding.css';
export default function CoreBaseLandingPage() {
  const navigate = useNavigate();
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  return <div className="pl"><CoreBaseHero isAuthenticated={isAuthenticated} onLogin={() => navigate('/login')} /><CoreBaseSections /></div>;
}
